// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedCountry {
  ABW: {"enum_constant":"ABW"};
  AFG: {"enum_constant":"AFG"};
  AGO: {"enum_constant":"AGO"};
  AIA: {"enum_constant":"AIA"};
  ALA: {"enum_constant":"ALA"};
  ALB: {"enum_constant":"ALB"};
  AND: {"enum_constant":"AND"};
  ARE: {"enum_constant":"ARE"};
  ARG: {"enum_constant":"ARG"};
  ARM: {"enum_constant":"ARM"};
  ASM: {"enum_constant":"ASM"};
  ATA: {"enum_constant":"ATA"};
  ATF: {"enum_constant":"ATF"};
  ATG: {"enum_constant":"ATG"};
  AUS: {"enum_constant":"AUS"};
  AUT: {"enum_constant":"AUT"};
  AZE: {"enum_constant":"AZE"};
  BDI: {"enum_constant":"BDI"};
  BEL: {"enum_constant":"BEL"};
  BEN: {"enum_constant":"BEN"};
  BES: {"enum_constant":"BES"};
  BFA: {"enum_constant":"BFA"};
  BGD: {"enum_constant":"BGD"};
  BGR: {"enum_constant":"BGR"};
  BHR: {"enum_constant":"BHR"};
  BHS: {"enum_constant":"BHS"};
  BIH: {"enum_constant":"BIH"};
  BLM: {"enum_constant":"BLM"};
  BLR: {"enum_constant":"BLR"};
  BLZ: {"enum_constant":"BLZ"};
  BMU: {"enum_constant":"BMU"};
  BOL: {"enum_constant":"BOL"};
  BRA: {"enum_constant":"BRA"};
  BRB: {"enum_constant":"BRB"};
  BRN: {"enum_constant":"BRN"};
  BTN: {"enum_constant":"BTN"};
  BVT: {"enum_constant":"BVT"};
  BWA: {"enum_constant":"BWA"};
  CAF: {"enum_constant":"CAF"};
  CAN: {"enum_constant":"CAN"};
  CCK: {"enum_constant":"CCK"};
  CHE: {"enum_constant":"CHE"};
  CHL: {"enum_constant":"CHL"};
  CHN: {"enum_constant":"CHN"};
  CIV: {"enum_constant":"CIV"};
  CMR: {"enum_constant":"CMR"};
  COD: {"enum_constant":"COD"};
  COG: {"enum_constant":"COG"};
  COK: {"enum_constant":"COK"};
  COL: {"enum_constant":"COL"};
  COM: {"enum_constant":"COM"};
  CPV: {"enum_constant":"CPV"};
  CRI: {"enum_constant":"CRI"};
  CUB: {"enum_constant":"CUB"};
  CUW: {"enum_constant":"CUW"};
  CXR: {"enum_constant":"CXR"};
  CYM: {"enum_constant":"CYM"};
  CYP: {"enum_constant":"CYP"};
  CZE: {"enum_constant":"CZE"};
  DEU: {"enum_constant":"DEU"};
  DJI: {"enum_constant":"DJI"};
  DMA: {"enum_constant":"DMA"};
  DNK: {"enum_constant":"DNK"};
  DOM: {"enum_constant":"DOM"};
  DZA: {"enum_constant":"DZA"};
  ECU: {"enum_constant":"ECU"};
  EGY: {"enum_constant":"EGY"};
  ERI: {"enum_constant":"ERI"};
  ESH: {"enum_constant":"ESH"};
  ESP: {"enum_constant":"ESP"};
  EST: {"enum_constant":"EST"};
  ETH: {"enum_constant":"ETH"};
  FIN: {"enum_constant":"FIN"};
  FJI: {"enum_constant":"FJI"};
  FLK: {"enum_constant":"FLK"};
  FRA: {"enum_constant":"FRA"};
  FRO: {"enum_constant":"FRO"};
  FSM: {"enum_constant":"FSM"};
  GAB: {"enum_constant":"GAB"};
  GBR: {"enum_constant":"GBR"};
  GEO: {"enum_constant":"GEO"};
  GGY: {"enum_constant":"GGY"};
  GHA: {"enum_constant":"GHA"};
  GIB: {"enum_constant":"GIB"};
  GIN: {"enum_constant":"GIN"};
  GLP: {"enum_constant":"GLP"};
  GMB: {"enum_constant":"GMB"};
  GNB: {"enum_constant":"GNB"};
  GNQ: {"enum_constant":"GNQ"};
  GRC: {"enum_constant":"GRC"};
  GRD: {"enum_constant":"GRD"};
  GRL: {"enum_constant":"GRL"};
  GTM: {"enum_constant":"GTM"};
  GUF: {"enum_constant":"GUF"};
  GUM: {"enum_constant":"GUM"};
  GUY: {"enum_constant":"GUY"};
  HKG: {"enum_constant":"HKG"};
  HMD: {"enum_constant":"HMD"};
  HND: {"enum_constant":"HND"};
  HRV: {"enum_constant":"HRV"};
  HTI: {"enum_constant":"HTI"};
  HUN: {"enum_constant":"HUN"};
  IDN: {"enum_constant":"IDN"};
  IMN: {"enum_constant":"IMN"};
  IND: {"enum_constant":"IND"};
  IOT: {"enum_constant":"IOT"};
  IRL: {"enum_constant":"IRL"};
  IRN: {"enum_constant":"IRN"};
  IRQ: {"enum_constant":"IRQ"};
  ISL: {"enum_constant":"ISL"};
  ISR: {"enum_constant":"ISR"};
  ITA: {"enum_constant":"ITA"};
  JAM: {"enum_constant":"JAM"};
  JEY: {"enum_constant":"JEY"};
  JOR: {"enum_constant":"JOR"};
  JPN: {"enum_constant":"JPN"};
  KAZ: {"enum_constant":"KAZ"};
  KEN: {"enum_constant":"KEN"};
  KGZ: {"enum_constant":"KGZ"};
  KHM: {"enum_constant":"KHM"};
  KIR: {"enum_constant":"KIR"};
  KNA: {"enum_constant":"KNA"};
  KOR: {"enum_constant":"KOR"};
  KWT: {"enum_constant":"KWT"};
  LAO: {"enum_constant":"LAO"};
  LBN: {"enum_constant":"LBN"};
  LBR: {"enum_constant":"LBR"};
  LBY: {"enum_constant":"LBY"};
  LCA: {"enum_constant":"LCA"};
  LIE: {"enum_constant":"LIE"};
  LKA: {"enum_constant":"LKA"};
  LSO: {"enum_constant":"LSO"};
  LTU: {"enum_constant":"LTU"};
  LUX: {"enum_constant":"LUX"};
  LVA: {"enum_constant":"LVA"};
  MAC: {"enum_constant":"MAC"};
  MAF: {"enum_constant":"MAF"};
  MAR: {"enum_constant":"MAR"};
  MCO: {"enum_constant":"MCO"};
  MDA: {"enum_constant":"MDA"};
  MDG: {"enum_constant":"MDG"};
  MDV: {"enum_constant":"MDV"};
  MEX: {"enum_constant":"MEX"};
  MHL: {"enum_constant":"MHL"};
  MKD: {"enum_constant":"MKD"};
  MLI: {"enum_constant":"MLI"};
  MLT: {"enum_constant":"MLT"};
  MMR: {"enum_constant":"MMR"};
  MNE: {"enum_constant":"MNE"};
  MNG: {"enum_constant":"MNG"};
  MNP: {"enum_constant":"MNP"};
  MOZ: {"enum_constant":"MOZ"};
  MRT: {"enum_constant":"MRT"};
  MSR: {"enum_constant":"MSR"};
  MTQ: {"enum_constant":"MTQ"};
  MUS: {"enum_constant":"MUS"};
  MWI: {"enum_constant":"MWI"};
  MYS: {"enum_constant":"MYS"};
  MYT: {"enum_constant":"MYT"};
  NAM: {"enum_constant":"NAM"};
  NCL: {"enum_constant":"NCL"};
  NER: {"enum_constant":"NER"};
  NFK: {"enum_constant":"NFK"};
  NGA: {"enum_constant":"NGA"};
  NIC: {"enum_constant":"NIC"};
  NIU: {"enum_constant":"NIU"};
  NLD: {"enum_constant":"NLD"};
  NOR: {"enum_constant":"NOR"};
  NPL: {"enum_constant":"NPL"};
  NRU: {"enum_constant":"NRU"};
  NZL: {"enum_constant":"NZL"};
  OMN: {"enum_constant":"OMN"};
  PAK: {"enum_constant":"PAK"};
  PAN: {"enum_constant":"PAN"};
  PCN: {"enum_constant":"PCN"};
  PER: {"enum_constant":"PER"};
  PHL: {"enum_constant":"PHL"};
  PLW: {"enum_constant":"PLW"};
  PNG: {"enum_constant":"PNG"};
  POL: {"enum_constant":"POL"};
  PRI: {"enum_constant":"PRI"};
  PRK: {"enum_constant":"PRK"};
  PRT: {"enum_constant":"PRT"};
  PRY: {"enum_constant":"PRY"};
  PSE: {"enum_constant":"PSE"};
  PYF: {"enum_constant":"PYF"};
  QAT: {"enum_constant":"QAT"};
  REU: {"enum_constant":"REU"};
  ROU: {"enum_constant":"ROU"};
  RUS: {"enum_constant":"RUS"};
  RWA: {"enum_constant":"RWA"};
  SAU: {"enum_constant":"SAU"};
  SDN: {"enum_constant":"SDN"};
  SEN: {"enum_constant":"SEN"};
  SGP: {"enum_constant":"SGP"};
  SGS: {"enum_constant":"SGS"};
  SHN: {"enum_constant":"SHN"};
  SJM: {"enum_constant":"SJM"};
  SLB: {"enum_constant":"SLB"};
  SLE: {"enum_constant":"SLE"};
  SLV: {"enum_constant":"SLV"};
  SMR: {"enum_constant":"SMR"};
  SOM: {"enum_constant":"SOM"};
  SPM: {"enum_constant":"SPM"};
  SRB: {"enum_constant":"SRB"};
  SSD: {"enum_constant":"SSD"};
  STP: {"enum_constant":"STP"};
  SUR: {"enum_constant":"SUR"};
  SVK: {"enum_constant":"SVK"};
  SVN: {"enum_constant":"SVN"};
  SWE: {"enum_constant":"SWE"};
  SWZ: {"enum_constant":"SWZ"};
  SXM: {"enum_constant":"SXM"};
  SYC: {"enum_constant":"SYC"};
  SYR: {"enum_constant":"SYR"};
  TCA: {"enum_constant":"TCA"};
  TCD: {"enum_constant":"TCD"};
  TGO: {"enum_constant":"TGO"};
  THA: {"enum_constant":"THA"};
  TJK: {"enum_constant":"TJK"};
  TKL: {"enum_constant":"TKL"};
  TKM: {"enum_constant":"TKM"};
  TLS: {"enum_constant":"TLS"};
  TON: {"enum_constant":"TON"};
  TTO: {"enum_constant":"TTO"};
  TUN: {"enum_constant":"TUN"};
  TUR: {"enum_constant":"TUR"};
  TUV: {"enum_constant":"TUV"};
  TWN: {"enum_constant":"TWN"};
  TZA: {"enum_constant":"TZA"};
  UGA: {"enum_constant":"UGA"};
  UKR: {"enum_constant":"UKR"};
  UMI: {"enum_constant":"UMI"};
  URY: {"enum_constant":"URY"};
  USA: {"enum_constant":"USA"};
  UZB: {"enum_constant":"UZB"};
  VAT: {"enum_constant":"VAT"};
  VCT: {"enum_constant":"VCT"};
  VEN: {"enum_constant":"VEN"};
  VGB: {"enum_constant":"VGB"};
  VIR: {"enum_constant":"VIR"};
  VNM: {"enum_constant":"VNM"};
  VUT: {"enum_constant":"VUT"};
  WLF: {"enum_constant":"WLF"};
  WSM: {"enum_constant":"WSM"};
  XKX: {"enum_constant":"XKX"};
  YEM: {"enum_constant":"YEM"};
  ZAF: {"enum_constant":"ZAF"};
  ZMB: {"enum_constant":"ZMB"};
  ZWE: {"enum_constant":"ZWE"};
}

export type CountryId = keyof IParsedCountry;
export type CountryData = IParsedCountry[CountryId];
const data: CountryData[] = [{"enum_constant":"ABW"},{"enum_constant":"AFG"},{"enum_constant":"AGO"},{"enum_constant":"AIA"},{"enum_constant":"ALA"},{"enum_constant":"ALB"},{"enum_constant":"AND"},{"enum_constant":"ARE"},{"enum_constant":"ARG"},{"enum_constant":"ARM"},{"enum_constant":"ASM"},{"enum_constant":"ATA"},{"enum_constant":"ATF"},{"enum_constant":"ATG"},{"enum_constant":"AUS"},{"enum_constant":"AUT"},{"enum_constant":"AZE"},{"enum_constant":"BDI"},{"enum_constant":"BEL"},{"enum_constant":"BEN"},{"enum_constant":"BES"},{"enum_constant":"BFA"},{"enum_constant":"BGD"},{"enum_constant":"BGR"},{"enum_constant":"BHR"},{"enum_constant":"BHS"},{"enum_constant":"BIH"},{"enum_constant":"BLM"},{"enum_constant":"BLR"},{"enum_constant":"BLZ"},{"enum_constant":"BMU"},{"enum_constant":"BOL"},{"enum_constant":"BRA"},{"enum_constant":"BRB"},{"enum_constant":"BRN"},{"enum_constant":"BTN"},{"enum_constant":"BVT"},{"enum_constant":"BWA"},{"enum_constant":"CAF"},{"enum_constant":"CAN"},{"enum_constant":"CCK"},{"enum_constant":"CHE"},{"enum_constant":"CHL"},{"enum_constant":"CHN"},{"enum_constant":"CIV"},{"enum_constant":"CMR"},{"enum_constant":"COD"},{"enum_constant":"COG"},{"enum_constant":"COK"},{"enum_constant":"COL"},{"enum_constant":"COM"},{"enum_constant":"CPV"},{"enum_constant":"CRI"},{"enum_constant":"CUB"},{"enum_constant":"CUW"},{"enum_constant":"CXR"},{"enum_constant":"CYM"},{"enum_constant":"CYP"},{"enum_constant":"CZE"},{"enum_constant":"DEU"},{"enum_constant":"DJI"},{"enum_constant":"DMA"},{"enum_constant":"DNK"},{"enum_constant":"DOM"},{"enum_constant":"DZA"},{"enum_constant":"ECU"},{"enum_constant":"EGY"},{"enum_constant":"ERI"},{"enum_constant":"ESH"},{"enum_constant":"ESP"},{"enum_constant":"EST"},{"enum_constant":"ETH"},{"enum_constant":"FIN"},{"enum_constant":"FJI"},{"enum_constant":"FLK"},{"enum_constant":"FRA"},{"enum_constant":"FRO"},{"enum_constant":"FSM"},{"enum_constant":"GAB"},{"enum_constant":"GBR"},{"enum_constant":"GEO"},{"enum_constant":"GGY"},{"enum_constant":"GHA"},{"enum_constant":"GIB"},{"enum_constant":"GIN"},{"enum_constant":"GLP"},{"enum_constant":"GMB"},{"enum_constant":"GNB"},{"enum_constant":"GNQ"},{"enum_constant":"GRC"},{"enum_constant":"GRD"},{"enum_constant":"GRL"},{"enum_constant":"GTM"},{"enum_constant":"GUF"},{"enum_constant":"GUM"},{"enum_constant":"GUY"},{"enum_constant":"HKG"},{"enum_constant":"HMD"},{"enum_constant":"HND"},{"enum_constant":"HRV"},{"enum_constant":"HTI"},{"enum_constant":"HUN"},{"enum_constant":"IDN"},{"enum_constant":"IMN"},{"enum_constant":"IND"},{"enum_constant":"IOT"},{"enum_constant":"IRL"},{"enum_constant":"IRN"},{"enum_constant":"IRQ"},{"enum_constant":"ISL"},{"enum_constant":"ISR"},{"enum_constant":"ITA"},{"enum_constant":"JAM"},{"enum_constant":"JEY"},{"enum_constant":"JOR"},{"enum_constant":"JPN"},{"enum_constant":"KAZ"},{"enum_constant":"KEN"},{"enum_constant":"KGZ"},{"enum_constant":"KHM"},{"enum_constant":"KIR"},{"enum_constant":"KNA"},{"enum_constant":"KOR"},{"enum_constant":"KWT"},{"enum_constant":"LAO"},{"enum_constant":"LBN"},{"enum_constant":"LBR"},{"enum_constant":"LBY"},{"enum_constant":"LCA"},{"enum_constant":"LIE"},{"enum_constant":"LKA"},{"enum_constant":"LSO"},{"enum_constant":"LTU"},{"enum_constant":"LUX"},{"enum_constant":"LVA"},{"enum_constant":"MAC"},{"enum_constant":"MAF"},{"enum_constant":"MAR"},{"enum_constant":"MCO"},{"enum_constant":"MDA"},{"enum_constant":"MDG"},{"enum_constant":"MDV"},{"enum_constant":"MEX"},{"enum_constant":"MHL"},{"enum_constant":"MKD"},{"enum_constant":"MLI"},{"enum_constant":"MLT"},{"enum_constant":"MMR"},{"enum_constant":"MNE"},{"enum_constant":"MNG"},{"enum_constant":"MNP"},{"enum_constant":"MOZ"},{"enum_constant":"MRT"},{"enum_constant":"MSR"},{"enum_constant":"MTQ"},{"enum_constant":"MUS"},{"enum_constant":"MWI"},{"enum_constant":"MYS"},{"enum_constant":"MYT"},{"enum_constant":"NAM"},{"enum_constant":"NCL"},{"enum_constant":"NER"},{"enum_constant":"NFK"},{"enum_constant":"NGA"},{"enum_constant":"NIC"},{"enum_constant":"NIU"},{"enum_constant":"NLD"},{"enum_constant":"NOR"},{"enum_constant":"NPL"},{"enum_constant":"NRU"},{"enum_constant":"NZL"},{"enum_constant":"OMN"},{"enum_constant":"PAK"},{"enum_constant":"PAN"},{"enum_constant":"PCN"},{"enum_constant":"PER"},{"enum_constant":"PHL"},{"enum_constant":"PLW"},{"enum_constant":"PNG"},{"enum_constant":"POL"},{"enum_constant":"PRI"},{"enum_constant":"PRK"},{"enum_constant":"PRT"},{"enum_constant":"PRY"},{"enum_constant":"PSE"},{"enum_constant":"PYF"},{"enum_constant":"QAT"},{"enum_constant":"REU"},{"enum_constant":"ROU"},{"enum_constant":"RUS"},{"enum_constant":"RWA"},{"enum_constant":"SAU"},{"enum_constant":"SDN"},{"enum_constant":"SEN"},{"enum_constant":"SGP"},{"enum_constant":"SGS"},{"enum_constant":"SHN"},{"enum_constant":"SJM"},{"enum_constant":"SLB"},{"enum_constant":"SLE"},{"enum_constant":"SLV"},{"enum_constant":"SMR"},{"enum_constant":"SOM"},{"enum_constant":"SPM"},{"enum_constant":"SRB"},{"enum_constant":"SSD"},{"enum_constant":"STP"},{"enum_constant":"SUR"},{"enum_constant":"SVK"},{"enum_constant":"SVN"},{"enum_constant":"SWE"},{"enum_constant":"SWZ"},{"enum_constant":"SXM"},{"enum_constant":"SYC"},{"enum_constant":"SYR"},{"enum_constant":"TCA"},{"enum_constant":"TCD"},{"enum_constant":"TGO"},{"enum_constant":"THA"},{"enum_constant":"TJK"},{"enum_constant":"TKL"},{"enum_constant":"TKM"},{"enum_constant":"TLS"},{"enum_constant":"TON"},{"enum_constant":"TTO"},{"enum_constant":"TUN"},{"enum_constant":"TUR"},{"enum_constant":"TUV"},{"enum_constant":"TWN"},{"enum_constant":"TZA"},{"enum_constant":"UGA"},{"enum_constant":"UKR"},{"enum_constant":"UMI"},{"enum_constant":"URY"},{"enum_constant":"USA"},{"enum_constant":"UZB"},{"enum_constant":"VAT"},{"enum_constant":"VCT"},{"enum_constant":"VEN"},{"enum_constant":"VGB"},{"enum_constant":"VIR"},{"enum_constant":"VNM"},{"enum_constant":"VUT"},{"enum_constant":"WLF"},{"enum_constant":"WSM"},{"enum_constant":"XKX"},{"enum_constant":"YEM"},{"enum_constant":"ZAF"},{"enum_constant":"ZMB"},{"enum_constant":"ZWE"}];
export default data;
